export default {"src":"/_next/static/media/powered-by-vercel.f90847c6.svg","height":44,"width":212,"blurWidth":0,"blurHeight":0};